import React, { PropsWithChildren } from 'react'
import { Box } from 'rebass'
import { ModuleSection, IModuleSectionProps } from '../ModuleSection/ModuleSection'
import { ICMSTextV2Props, TextV2 as Text } from '../Text/TextV2'
import { TextBlockList } from '../TextBlockList/TextBlockList'
import { ActionButton } from '../ActionButton/ActionButton'
import { StoryCardList } from '../StoryCardList/StoryCardList'
import { BillboardImage } from '../BillboardWithImage/BillboardImage'
import {
  ComponentType,
  ITextComponent,
  ITextBlockListComponent,
  IActionButtonComponent,
  IStoryCardListComponent,
  IBillboardImageComponent,
} from '../types/componentType'

export type ILookupComponent =
  | ITextComponent
  | ITextBlockListComponent
  | IActionButtonComponent
  | IStoryCardListComponent
  | IBillboardImageComponent

export const LookupComponent = (component: ILookupComponent) => {
  switch (component.type) {
    case ComponentType.Text:
      return <Text {...component.props} sx={{ textAlign: 'center', ...(component.props.sx || {}) }} />
    case ComponentType.TextBlockList:
      return (
        <Box>
          <TextBlockList {...component.props} sx={{ alignItems: 'center', ...(component.props.sx || {}) }} />
        </Box>
      )
    case ComponentType.ActionButton:
      return <ActionButton {...component.props} sx={{ marginTop: '32px', ...(component.props.sx || {}) }} />
    case ComponentType.StoryCardList:
      return <StoryCardList {...component.props} />
    case ComponentType.BillboardImage:
      return <BillboardImage {...component.props} />
  }
}

export interface ITextBlockProps extends IModuleSectionProps {
  title?: ICMSTextV2Props
  body?: ILookupComponent[]
}

export const TextBlock = ({ title, body, ...moduleSectionProps }: PropsWithChildren<ITextBlockProps>) => {
  return (
    <ModuleSection {...moduleSectionProps}>
      <Box
        className="container"
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        {title ? (
          <Text
            tag={title.tag}
            textFontColor={title.textFontColor}
            textFontStyle={title.textFontStyle}
            mobileText={title.mobileText}
            sx={{
              textAlign: 'center',
              paddingBottom: '10px',
              ...title.sx,
            }}
          >
            {title.text}
          </Text>
        ) : null}
        {body ? body.map((item, index) => <LookupComponent key={`body-component-${index}`} {...item} />) : null}
      </Box>
    </ModuleSection>
  )
}
